













































import { Component, Vue, Prop } from 'nuxt-property-decorator'
// https://github.com/rdunk/sanity-blocks-vue-component#full-example
import BlockContent from 'sanity-blocks-vue-component'
// import BlogTagList from '~/components/Blog/BlogTagList.vue'
import DateTime from '~/components/Other/Format/DateTime.vue'
import PostImage from '~/components/Post/PostImage.vue'

@Component({
  name: 'PostItem',
  components: {
    BlockContent,
    DateTime,
    PostImage
    // BlogTagList
  }
})
export default class extends Vue {
  @Prop() item
  @Prop() type
  @Prop() section

  serializers = {
    types: {
      mainImage: PostImage
    }
  }
}
